// src/components/FeaturedCategories.js
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { getHomepageFeaturedCategories } from "../services/homepage.api";

function FeaturedCategories() {
  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const [cards, setCards] = useState([]);

  const TEXT = {
    EN: { explore: "SHOP NOW" },
    AR: { explore: "تسوقي الآن" },
  };

  useEffect(() => {
    getHomepageFeaturedCategories().then(setCards).catch(() => {});
  }, []);

  return (
    <div className="w-full grid grid-cols-2 gap-2 px-0 mt-1 mb-0 overflow-x-hidden">
      {cards.map((card, i) => (
        <button
          key={card.id}
          onClick={() => {
  const key = card.category_slug;

  if (["new-in", "sale", "bestsellers"].includes(key)) {
    navigate(`/products/${key}`);
  } else {
    navigate(`/products/category/${key}`);
  }
}}

          className="
            relative overflow-hidden
            bg-black group
            h-56 md:h-auto
            transition-all duration-300
            hover:shadow-[0_0_25px_rgba(46,150,42,0.6)]
            hover:-translate-y-1
            card-3d animate-fadeInSeason
            rounded-none
          "
          style={{ animationDelay: `${i * 0.15}s` }}
        >
          {/* MOBILE IMAGE */}
          <img
            src={card.mobile_image}
            alt={lang === "EN" ? card.title_en : card.title_ar}
            className="
              md:hidden 
              w-full h-full object-cover
              transition-transform duration-[900ms]
              group-hover:scale-110
            "
          />

          {/* DESKTOP IMAGE */}
          <img
            src={card.desktop_image}
            alt={lang === "EN" ? card.title_en : card.title_ar}
            className="
              hidden md:block 
              w-full 
              h-56 md:h-[380px] lg:h-[480px] xl:h-[560px] 
              object-cover 
              transition-transform duration-[900ms]
              group-hover:scale-110
            "
          />

          {/* DARK TACTICAL OVERLAY */}
          <div
            className="
              absolute inset-0 
              bg-black/40
              opacity-60
              group-hover:opacity-70
              transition-opacity duration-300
            "
          />

          {/* HUD GRID */}
          <div className="absolute inset-0 hud-grid opacity-20 pointer-events-none" />

          {/* SHINE SWEEP */}
          <div
            className="
              absolute inset-0 pointer-events-none
              opacity-0 group-hover:opacity-30
              shine-effect
            "
          />

          {/* TEXT */}
          <div
            className="
              absolute bottom-3 md:bottom-5 
              w-full flex flex-col items-center text-center 
              transition-all duration-300 
              group-hover:bottom-6
              opacity-0 animate-textRevealSeason
            "
          >
            <p
              className="
                text-xs md:text-base lg:text-lg 
                font-semibold tracking-widest
                text-white
                drop-shadow-[0_0_8px_rgba(0,0,0,0.9)]
              "
              dir={lang === "AR" ? "rtl" : "ltr"}
            >
              {lang === "EN" ? card.title_en : card.title_ar}
            </p>

            <span
              className="
    underline
    text-[#9CB8A1]
    text-[10px] md:text-sm lg:text-base 
    tracking-widest
    drop-shadow-[0_0_4px_rgba(0,0,0,0.6)]
    opacity-90
    group-hover:opacity-100
    transition
  "
              dir={lang === "AR" ? "rtl" : "ltr"}
            >
              {TEXT[lang]?.explore}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
}

export default FeaturedCategories;
